module.exports = __webpack_public_path__ + "img/icons B_15.02fad2c9.png";